"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gameWidth_1 = __importDefault(require("../../constants/gameWidth"));
const drawText_1 = __importDefault(require("./drawText"));
const drawRectangle_1 = __importDefault(require("./drawRectangle"));
const state_1 = __importDefault(require("../../state"));
const drawImage_1 = __importDefault(require("./drawImage"));
const ZIndexType_1 = __importDefault(require("../../enums/ZIndexType"));
const levelIsCompleted_1 = __importDefault(require("../levelIsCompleted"));
const getPausedTime_1 = __importDefault(require("../getPausedTime"));
const drawTimer = () => {
    const endTime = (0, levelIsCompleted_1.default)() ? state_1.default.levelCompletedAt : state_1.default.currentTime;
    const offset = 4;
    const width = 26;
    const height = 11;
    const timeLeft = state_1.default.level.time - (endTime - state_1.default.levelStartedAt) + (0, getPausedTime_1.default)();
    const secondsLeft = Math.floor(timeLeft / 1000);
    const hungerZIndex = {
        type: ZIndexType_1.default.Hard,
        value: 10003
    };
    const percent = 1 - secondsLeft / state_1.default.level.time * 1000;
    const frame = percent < 1 / 3
        ? 0
        : percent < 2 / 3
            ? 1
            : 2;
    (0, drawImage_1.default)("hunger", 1, frame * 14, 0, 14, 14, gameWidth_1.default - offset - width - 17, offset - 2, 14, 14, hungerZIndex);
    (0, drawText_1.default)(`${Math.floor(secondsLeft / 60)}:${`${secondsLeft % 60}`.padStart(2, "0")}`, frame === 2 ? "#fd3232" : "#ffffff", gameWidth_1.default - offset - 2, offset + 2, 1, gameWidth_1.default, 1, "right", "top");
    (0, drawRectangle_1.default)("#000000", .25, gameWidth_1.default - offset - width, offset, width, height, 10003);
};
exports.default = drawTimer;
